import { useMemo } from 'react';

import { useUploadEstimatedTime } from '@air/feature-uploads/hooks';
import { formatEstimatedCompletionTime, formatUploadSpeedText } from '@air/feature-uploads/utils';
import { uploadingSpeedSelector } from '@air/redux-uploader';

import { useAirSelector } from '~/utils/ReduxUtils';

export const useWorkspaceUploadsProgressingLabel = () => {
  const { estimatedTime } = useUploadEstimatedTime();
  const speed = useAirSelector(uploadingSpeedSelector);

  const progressingLabel = useMemo(() => {
    const { formattedCompletionTime, showSpeed } = formatEstimatedCompletionTime(estimatedTime);
    const formattedSpeed = formatUploadSpeedText(speed);

    if (!formattedSpeed) {
      return 'Uploading';
    }

    if (showSpeed && formattedCompletionTime) {
      return `${formattedCompletionTime} · ${formattedSpeed}`;
    }

    return formattedCompletionTime ?? 'Uploading';
  }, [estimatedTime, speed]);

  return { progressingLabel };
};
